import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PlayerComponent } from '../../components/player/player.component';
import { ToasterService } from '../../components/toaster/toaster.service';
import { PlaylistService } from '../../services/playlist.service';
import { SocketService } from '../../services/socket.service';
import { PlayerService } from '../../services/player.service';

@Component({
  selector: 'tv',
  imports: [PlayerComponent],
  templateUrl: './tv.component.html',
  styleUrl: './tv.component.scss',
})
export class TvComponent {
  private socketService = inject(SocketService);
  private toaster = inject(ToasterService);
  private playlistService = inject(PlaylistService);
  private playerService = inject(PlayerService);
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.socketService.connect();
    this.socketService.onVideoAdded();
    this.socketService.onNowPlaying();

    this.socketService.videoAdded$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(video => {
        this.playlistService.loadNext();
        console.log('📼 New video added:', video);
        this.toaster.newVideoAdded(video);
      });

    this.socketService.nowPlaying$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(video => {
        this.playerService.loadVideo(video.youtubeId);
        this.playlistService.nowPlaying.set(video);
      });
  }
}
